import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { BedroomsContainer } from '../../containers/filters/BedroomsContainer';

export const bedrooms: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: BedroomsContainer,
};
